import Tooltip from '@material-ui/core/Tooltip'
import { withStyles, Theme } from '@material-ui/core/styles'

export default withStyles((theme: Theme) => ({
  arrow: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    fontSize: 12,
    backgroundColor: theme.palette.primary.main,
    maxWidth: 300,
    //'@media (min-width: 768px)': {
    '@media (min-width: 375px)': {
      maxWidth: 600,
    },
  },
  tooltipPlacementTop: {
    top: 15,
    '@media (min-width: 768px)': {
      //'@media (min-width: 375px)': {
      top: 5,
    },
  },
  tooltipPlacementBottom: {
    bottom: 15,
    '@media (min-width: 768px)': {
      //'@media (min-width: 375px)': {
      bottom: 5,
    },
  },
}))(Tooltip)
